export enum ModalType {
	ERROR = '@@ERROR',
	WARNING = '@@WARNING',
	INFO = '@@INFO',
	SUCCESS = '@@SUCCESS',
	CUSTOM = '@@CUSTOM',
}

export enum ModalButtonType {
	PRIMARY = '@@PRIMARY',
	SECONDARY = '@@SECONDARY',
}

export interface ModalButton {
	text: string;
	type?: ModalButtonType;
	routeTo?: string;
	onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
	closeOnClick?: boolean;
}
